export default __webpack_public_path__ + "static/bach_air-8ee2a045d9acd724f5b59dcd3dfa50ee.mp3";